import { HeadingProps } from '../types/Generics/HeadingProps';

export const Heading = (props: HeadingProps) => {
  return (
    <p id={props.id} className="mb-4 place-self-center text-4xl font-bold">
      {props.textContent}
    </p>
  );
};
